module.exports = __webpack_public_path__ + "img/One.24a34b9c.jpg";